import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  TelegramIcon,
  EmailIcon,
} from "react-share";

const ShareSection = ({ title }) => {
  const shareUrl = window.location.href;

  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
      
      <WhatsappShareButton url={shareUrl} title={title}>
        <WhatsappIcon size={40} round />
      </WhatsappShareButton>

      <FacebookShareButton url={shareUrl} quote={title}>
        <FacebookIcon size={40} round />
      </FacebookShareButton>

      <TwitterShareButton url={shareUrl} title={title}>
        <TwitterIcon size={40} round />
      </TwitterShareButton>

      <LinkedinShareButton url={shareUrl} title={title}>
        <LinkedinIcon size={40} round />
      </LinkedinShareButton>

      <TelegramShareButton url={shareUrl} title={title}>
        <TelegramIcon size={40} round />
      </TelegramShareButton>

      <EmailShareButton url={shareUrl} subject={title}>
        <EmailIcon size={40} round />
      </EmailShareButton>

    </div>
  );
};

export default ShareSection;